import BuyMeACoffee from './BuyMeACoffee';

export default function Footer() {
  return (
    <footer className="mt-auto p-5 text-center text-sm text-white/60 border-t border-white/10">
      <p className="mb-2">
        Made with care by stafidopsomo
      </p>
      <BuyMeACoffee variant="link" size="small" text="Support this project" />
    </footer>
  );
}
